import "./Generator.css";
import React, { Component } from "react";
import Header from "./Header";
// import Footer from "./Footer";
import Sketch from "./Sketch";
import History from "./History";
import InPaint from "./InPaint";
import Viewer from "./Viewer";
import Purchase from "./Purchase";
import Img2Img from "./Img2Img";
import Txt2Img from "./Txt2Img";
import ImgScaler from "./ImgScaler";
import TextPrompt from "./TextPrompt";
import ModalImage from "./ModalImage";
import RemoveBackground from "./RemoveBackground";
import ImageLoader from "./common/ImageLoader";
import SelectEngine from "./SelectEngine";
import Unclip from "./Unclip";
import axios from "axios";
import {
  MdOutlineDraw,
  MdPhotoSizeSelectLarge,
  MdOutlineVrpano,
} from "react-icons/md";
import { RiImageEditFill } from "react-icons/ri";
import { BsChatText, BsImage, BsImages, BsLayersHalf } from "react-icons/bs";
import { ImgTutorial, SketchTutorial, TextTutorial } from "./Tutorials";

class Generator extends Component {
  state = {
    user: {},
    authToken: "",
    prompt: "",
    start_schedule: 0.7,
    cfg_scale: 7,
    steps: 30,
    engine: "3",
    seed: 123456789,
    samples: 1,
    aspectRatio: "square",
    latestImage: "",
    history: [],
    initImage: null,
    latestImageURL: "./images/text_placeholder_square.png",
    historyModalDetails: {},
    loading: false,
    purchaseModalStatus: false,
    galeryItem: null,
    mode: "text",
    initImageURL: "./images/blanc.png",
    maskImage: null,
    openModalImage: false,
    openModalPrivacy: false,
    publishing: false,
    textTutorial: localStorage.getItem("textTutorial") === "true",
    imgTutorial: localStorage.getItem("imgTutorial") === "true",
    sketchTutorial: localStorage.getItem("sketchTutorial") === "true",
    faq: false,
  };

  openTutorial = (mode) => {
    this.setState({ [mode]: false });
  };

  handleUploadInitImage = (file, url) => {
    this.setState({
      initImage: file,
      initImageURL: URL.createObjectURL(file),
      // engine: "1",
    });
  };

  publish = (imageId) => {
    this.setState({ publishing: true });
    const formData = new FormData();
    formData.append("_id", imageId);
    axios
      .post(`${process.env.REACT_APP_BACKEND}/publish`, formData, {
        headers: {
          Authorization: `Bearer ${this.props.token}`,
        },
      })
      .then(async (response) => {
        this.setState({ publishing: false });
        alert("Yay! Your public post is up and running successfully! 🎉");
      })
      .catch((error) => {
        console.log(error);
        this.setState({ publishing: false });
      });
  };

  submit = async (prompt) => {
    this.setState({ loading: true });
    let params = {
      prompt: prompt,
      start_schedule: this.state.start_schedule,
      cfg_scale: this.state.cfg_scale,
      steps: this.state.steps,
      seed: Math.floor(Math.random() * (10000000 - 1000000) + 1000000),
      samples: this.state.samples,
      mode: this.state.mode,
      engine: this.state.engine,
      aspectRatio: this.state.aspectRatio,
    };

    if (this.state.initImage !== null && this.state.mode !== "text") {
      params.init_image = this.state.initImage;
    }
    if (this.state.initImage === null && this.state.mode !== "text") {
      alert("Oops! Don't forget to choose an image first! 🖼️");
      this.setState({ loading: false });
      return;
    }

    if (this.state.mode === "inpaint" && this.state.maskImage !== null) {
      params.mask_image = this.state.maskImage;
    } else if (this.state.mode === "inpaint") {
      alert("Mask is not set");
      this.setState({ loading: false });
      return;
    }

    const formData = new FormData();
    Object.keys(params).forEach((element) => {
      formData.append(element, params[element]);
    });
    axios
      .post(`${process.env.REACT_APP_BACKEND}/generate`, formData, {
        headers: {
          Authorization: `Bearer ${this.props.token}`,
        },
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
        timeout: 80000, // Increase timeout if necessary
      })
      .then(async (response) => {
        if (response.data.error !== undefined) {
          alert(response.data.error);
          this.setState({ loading: false });
          if (response.data.code === "credits") {
            this.setPurchaseModal(true);
          }
          return;
        }
        await this.props.updateUser(response.data.user);
        await this.props.updateHistory(response.data.params);
        this.setState({
          latestImageURL: response.data.params.imageHash,
          latestImageParams: response.data.params,
          loading: false,
          openModalImage:
            this.state.mode === "sketch" ||
            this.state.mode === "inpaint" ||
            this.state.mode === "scaler" ||
            this.state.mode === "unclip"
              ? true
              : false,
          prompt: response.data.params.prompt,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
      });
  };

  handleGalerySelection = async (params) => {
    const mode = this.state.mode;
    let imageURL = params.imageHash;
    if (this.state.mode !== "bgrem") {
      if (params.mode !== undefined && params.mode === "scaler") {
        imageURL = params.initImage; // otherwise we will be using a very large image as init
      }
    }
    // set the generated image as uploaded file for use in img2img if mode is img2img

    if (
      mode === "image" ||
      mode === "inpaint" ||
      mode === "scaler" ||
      mode === "bgrem" ||
      mode === "unclip"
    ) {
      const blob = await (await fetch(imageURL, { cache: "no-cache" })).blob();
      const file = new File([blob], "init_image.png", {
        type: "image/png",
        lastModified: new Date(),
      });

      this.setState({
        initImage: file,
        initImageURL: imageURL,
        galeryItem: params,
        prompt: params.prompt,
      });
      // take the user to the image displayed
    } else {
      this.setState({
        galeryItem: params,
        prompt: params.prompt,
      });
    }
    if (mode === "view" || mode === "image") {
      window.scrollTo(0, 0);
    }
  };

  handleSketchSave = async (dataURL) => {
    const blob = await (await fetch(dataURL)).blob();
    let state = {};
    if (this.state.mode === "inpaint") {
      const file = new File([blob], "mask_image.png", {
        type: "image/png",
        lastModified: new Date(),
      });
      state = { maskImage: file };
    } else {
      const file = new File([blob], "init_image.png", {
        type: "image/png",
        lastModified: new Date(),
      });
      state = { initImage: file, initImageURL: URL.createObjectURL(file) };
    }
    await this.setStateAsync(state);
  };

  setPurchaseModal = (status) => {
    this.setState({ purchaseModalStatus: status });
  };

  setAspectRatio = (value) => {
    let latestImageURL;
    let initImageURL;
    if (this.state.mode === "text") {
      latestImageURL = `./images/${this.state.mode}_placeholder_${value}.png`;
      initImageURL = `./images/${this.state.mode}_placeholder_${value}.png`;
    } else {
      latestImageURL = `./images/${this.state.mode}_placeholder.png`;
      initImageURL = `./images/${this.state.mode}_placeholder.png`;
    }
    this.setState({
      aspectRatio: value,
      latestImageURL: latestImageURL,
      initImageURL: initImageURL,
      initImage: null,
      latestImage: null,
      galeryItem: null,
    });
  };

  handleModes = (e) => {
    const name = e.currentTarget.getAttribute("name");
    this.clearCanvas(name);
    let latestImageURL;
    let initImageURL;
    if (name === "text") {
      latestImageURL = `./images/${name}_placeholder_${this.state.aspectRatio}.png`;
      initImageURL = `./images/${name}_placeholder_${this.state.aspectRatio}.png`;
    } else {
      latestImageURL = `./images/${name}_placeholder.png`;
      initImageURL = `./images/${name}_placeholder.png`;
    }

    let engine = name==="image"? "3":this.state.engine;
    this.setState({
      mode: name,
      latestImageURL: latestImageURL,
      initImageURL: initImageURL,
      initImage: null,
      latestImage: null,
      galeryItem: null,
      prompt: "",
      engine:engine,
    });
  };

  clearCanvas = (mode) => {
    this.setState({ latestImageURL: "./images/blanc.png" });
  };

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  handleCloseModalimage = () => {
    this.setState({ openModalImage: false });
  };

  handleDeleteImages = (imageId) => {
    const formData = new FormData();
    formData.append("_id", imageId);
    axios
      .post(`${process.env.REACT_APP_BACKEND}/delete-image`, formData, {
        headers: {
          Authorization: `Bearer ${this.props.token}`,
        },
      })
      .then(async (response) => {
        this.props.removeFromHistory(imageId, response.data.imageHash);
        this.setState({ galeryItem: null });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ publishing: false });
      });
  };

  setEngine = (engine) => {
    this.setState({ engine: engine });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const mode = this.state.mode;
    const images = [...this.props.imgHistory];
    const maxImages = Math.min(images.length, 90);
    const email = this.props.auth_user.email;
    return (
      <>
        <div style={{ height: "5vh" }}>
          <Header
            credits={this.props.user.credits}
            setPurchaseModal={this.setPurchaseModal}
            email={email}
            auth0={this.props.auth0}
            openPrivacyModal={() => this.setState({ openModalPrivacy: true })}
            history={this.props.history}
            deleteAccount={this.props.deleteAccount}
          />
        </div>
        <div className="container">
          <div className="generator">
            <div className="container-modes">
              <div
                className="modes"
                onClick={this.handleModes}
                name="text"
                disabled={mode === "text"}
                style={{ borderTop: mode === "text" ? "1px solid white" : "" }}
              >
                <BsChatText size={25} />
              </div>
              <div
                className="modes"
                onClick={this.handleModes}
                name="image"
                disabled={mode === "image"}
                style={{ borderTop: mode === "image" ? "1px solid white" : "" }}
              >
                <BsImage size={25} />
              </div>
              <div
                className="modes"
                onClick={this.handleModes}
                name="sketch"
                disabled={mode === "sketch"}
                style={{
                  borderTop: mode === "sketch" ? "1px solid white" : "",
                }}
              >
                <MdOutlineDraw size={25} />
              </div>
              <div
                className="modes"
                onClick={this.handleModes}
                name="inpaint"
                disabled={mode === "inpaint"}
                style={{
                  borderTop: mode === "inpaint" ? "1px solid white" : "",
                }}
              >
                <RiImageEditFill size={28} />
              </div>
              <div
                className="modes"
                onClick={this.handleModes}
                name="scaler"
                disabled={mode === "scaler"}
                style={{
                  borderTop: mode === "scaler" ? "1px solid white" : "",
                }}
              >
                <MdPhotoSizeSelectLarge size={28} />
              </div>
              <div
                className="modes"
                onClick={this.handleModes}
                name="bgrem"
                disabled={mode === "bgrem"}
                style={{ borderTop: mode === "bgrem" ? "1px solid white" : "" }}
              >
                <BsLayersHalf size={25} />
              </div>
              <div
                className="modes"
                onClick={this.handleModes}
                name="unclip"
                disabled={mode === "unclip"}
                style={{
                  borderTop: mode === "unclip" ? "1px solid white" : "",
                }}
              >
                <MdOutlineVrpano size={25} />
              </div>
              <div
                className="modes"
                onClick={this.handleModes}
                name="view"
                disabled={mode === "view"}
                style={{ borderTop: mode === "view" ? "1px solid white" : "" }}
              >
                <BsImages size={25} />
              </div>
            </div>

            <div style={{ height: "90%", width: "100%" }}>
              {mode === "unclip" && (
                <Unclip
                  loading={this.state.loading}
                  initImageURL={this.state.initImageURL}
                  submit={this.submit}
                  handleUploadInitImage={this.handleUploadInitImage}
                  prompt={this.state.prompt}
                />
              )}

              {mode === "sketch" && (
                <Sketch
                  handleSketchSave={this.handleSketchSave}
                  submit={this.submit}
                  prompt={this.state.prompt}
                  loading={this.state.loading}
                />
              )}

              {mode === "inpaint" && (
                <InPaint
                  handleSketchSave={this.handleSketchSave}
                  handleUploadInitImage={this.handleUploadInitImage}
                  submit={this.submit}
                  prompt={this.state.prompt}
                  loading={this.state.loading}
                  initImageURL={this.state.initImageURL}
                  galeryItem={this.state.galeryItem}
                />
              )}

              {mode === "text" && (
                <Txt2Img
                  loading={this.state.loading}
                  latestImageURL={this.state.latestImageURL}
                  openTutorial={this.openTutorial}
                />
              )}

              {mode === "view" && (
                <Viewer
                  galeryItem={this.state.galeryItem || images[0]}
                  images={images}
                  maxImages={maxImages}
                  publish={this.publish}
                  publishing={this.state.publishing}
                  handleDeleteImages={this.handleDeleteImages}
                />
              )}

              {mode === "scaler" && (
                <ImgScaler
                  loading={this.state.loading}
                  initImageURL={this.state.initImageURL}
                  submit={this.submit}
                  handleUploadInitImage={this.handleUploadInitImage}
                />
              )}

              {mode === "image" && (
                <div>
                <Img2Img
                  loading={this.state.loading}
                  latestImageURL={this.state.latestImageURL}
                  initImageURL={this.state.initImageURL}
                  handleUploadInitImage={this.handleUploadInitImage}
                />
                <TextPrompt submit={this.submit} prompt={this.state.prompt} />
                </div>
              )}

              {mode === "bgrem" && (
                <RemoveBackground
                  loading={this.state.loading}
                  latestImageURL={this.state.latestImageURL}
                  initImageURL={this.state.initImageURL}
                  handleUploadInitImage={this.handleUploadInitImage}
                  submit={this.submit}
                />
              )}

              {(mode === "text") && (
                <div style={{ height: "20%", width: "100%" }}>
                  <SelectEngine
                    setEngine={this.setEngine}
                    engine={this.state.engine}
                    mode={mode}
                    aspectRatio={this.state.aspectRatio}
                    setAspectRatio={this.setAspectRatio}
                  />

                  <TextPrompt submit={this.submit} prompt={this.state.prompt} />
                </div>
              )}

              {/* <div className="footer">Footer</div> */}
              <Purchase
                open={this.state.purchaseModalStatus}
                onClose={() => {
                  this.setState({ purchaseModalStatus: false });
                }}
                token={this.props.token}
                user={this.props.user}
                updateUser={this.props.updateUser}
              />

              <ModalImage
                open={this.state.openModalImage}
                image={this.state.latestImageParams}
                onClose={this.handleCloseModalimage}
                mode={mode}
              />

              {!this.state.textTutorial && mode === "text" && (
                <TextTutorial
                  close={() => {
                    this.setState({ textTutorial: true });
                  }}
                />
              )}
              {!this.state.imgTutorial && mode === "image" && (
                <ImgTutorial
                  close={() => {
                    this.setState({ imgTutorial: true });
                  }}
                />
              )}
              {!this.state.sketchTutorial && mode === "sketch" && (
                <SketchTutorial
                  close={() => {
                    this.setState({ sketchTutorial: true });
                  }}
                />
              )}
            </div>
          </div>

          <div className="container-history">
            <History
              handleGalerySelection={this.handleGalerySelection}
              images={images}
              getImages={this.props.getImages}
              totalImages={this.props.totalImages}
              mode={mode}
              handleDeleteImages={this.handleDeleteImages}
            />
          </div>
        </div>

        {/* <Footer /> */}

        {this.state.publishing === true && <ImageLoader />}
      </>
    );
  }
}

export default Generator;
